/** @module researches/charactersInUrl */

/**
 * Checks if the URL contains invalid characters (characters not in a-z or 0-9).
 *
 * @param {Paper} paper the Paper object to use in this count.
 *
 * @returns {{isInvalidCharacters: boolean}} Object indicating if the URL contains invalid characters.
 */
function charactersInUrl(paper) {
  const slug = paper.getSlug() || '';
  const newSlug = new URL(slug).pathname.split('/').pop();
  // Check if slug contains any characters that are NOT in a-z or 0-9
  // Regex matches any character that is NOT lowercase letter (a-z) or digit (0-9)
  const hasInvalidCharacters = /[^a-z0-9-]/.test(newSlug);
  return {
    isInvalidCharacters: hasInvalidCharacters
  };
}

export {charactersInUrl};
